import React, { useState } from 'react';
import styled from 'styled-components';
import TabContext from '@mui/lab/TabContext';

import { useSelector } from 'react-redux';
import { selectCommandByNodeId, State } from '@store/index';
import { TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import { NodeInputExpression, NodeSidebarTabsContainer } from '@common/Node/NodeSidebar';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 4rem;

  & .MuiTabPanel-root {
    padding: 0;
  }
`;

const TabContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 1.25rem;
  padding-top: 1.1rem;
  gap: 1.25rem;
`;

export const DelayTabs: React.FC = () => {
  const [tab, setTab] = useState('1');

  const command = useSelector((state: State) => selectCommandByNodeId(state, state.tabs.active.selectedNode));
  if (!command) return;

  const fields = command.fields;
  const delayField = fields.find((field) => field.id === 'delay');

  return (
    <Container>
      <TabContext value={tab}>
        <NodeSidebarTabsContainer color={command.config.background}>
          <TabList onChange={(_, newTab) => setTab(newTab)}>
            <Tab disableRipple label='Node' value='1' />
          </TabList>
        </NodeSidebarTabsContainer>
        <TabPanel value='1'>
          <TabContainer>
            {delayField && <NodeInputExpression key={delayField.id} field={delayField} command={command} />}
          </TabContainer>
        </TabPanel>
      </TabContext>
    </Container>
  );
};
